import './VideoScriptGeneratorModal.css';
import React from 'react';
import { useOnKeyPress } from '../../../utils/hooks/useOnKeyPress';
const VideoScriptGeneratorModal = _ref => {
  let {
    rtl,
    children,
    hide
  } = _ref;
  useOnKeyPress(["Escape", "Esc"], hide);
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    role: "dialog",
    "aria-labelledby": "videoScript-title"
  }, children);
};
VideoScriptGeneratorModal.displayName = "VideoScriptGeneratorModal";
export { VideoScriptGeneratorModal };
const commonStyles = "c16dmhxb";
const rtlStyles = "rzqbb9l";
const ltrStyles = "l1p0prel";